import { useMemo } from 'react';
import {
  QuestionnaireResponseItem,
  QuestionnaireItem,
} from '@medplum/fhirtypes';

//----------------------------------------------------------------------------

export const useRepeatableItemCount = (
  item: QuestionnaireItem,
  response: QuestionnaireResponseItem | undefined
) => {
  return useMemo(() => {
    if (!response) {
      return 1;
    }

    if (item.type === 'choice' || item.type === 'open-choice') {
      return 1;
    }

    // For group items, count the number of response items with the same linkId
    if (item.type === 'group') {
      // This is handled differently in the group components
      return 1;
    }

    const answers = response.answer;
    const count = answers?.length ? answers.length : 1;

    return count;
  }, [response, item]);
};

